module.exports = __webpack_public_path__ + "img/github-logoo.a6034cbe.svg";